// extracted by mini-css-extract-plugin
export var smbConnectBtn = "Artist-module--smbConnectBtn--uELmH";
export var smbHero = "Artist-module--smbHero--MD7di";
export var smbHeroBackgroundImg = "Artist-module--smbHeroBackgroundImg--dw-XA";
export var smbHeroForegroundImg = "Artist-module--smbHeroForegroundImg--3aogW";
export var smbScroll = "Artist-module--smbScroll--7bgmH";
export var smbViewLink = "Artist-module--smbViewLink--g-ebx";